module.exports = __webpack_public_path__ + "static/media/calendario.a10c674e.png";